import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
let { HEADER_ADMIN_BG_COLOR, HEADER_FONT_COLOR } = constants;

let styles = {
  base: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: HEADER_ADMIN_BG_COLOR,
    color: HEADER_FONT_COLOR,
    padding: '0 30px',
    boxSizing: 'border-box'
  },
  separator: {
    width: '100%'
  },
  settings: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 160
  },
  searchContainer: {
    width: '100%',
    maxWidth: 400,
    marginTop: 15
  },
  search: {
    borderRadius: 0,
    color: '#bbb',
    backgroundColor: HEADER_ADMIN_BG_COLOR,
    fontWeight: 400,
    borderBottom: `1px solid #666`,
    '::placeholder': {
      color: '#666'
    }
  },
  searchIcon: {
    color: '#666',
    left: 6
  },
  icon: {
    flexShrink: 0,
    fontSize: 20,
    cursor: 'pointer'
  },
  button: {
    flexShrink: 0,
    fontWeight: 500,
    textTransform: 'none'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/adminheader/AdminHeader.styles.js